import React, {useState} from "react";
import {Box, Button, Column, Columns, Field, Input, Select, Title} from "@allxsmith/bestax-bulma";
import TrackingOptionsPicker from "../TrackingCategory/TrackingOptionsPicker";


export default function NewMovementType({onSave, trackingOptions, trackingOptionObjects}){
    const [type, setType] = useState({
        name: "",
        trackingOption: trackingOptionObjects[Object.keys(trackingOptionObjects)[0]],
        invoice_address: "start"
    })
    const onChange = e => {
        let newType = {...type, [e.target.name]: e.target.value}
        setType(newType);
    };

    const onTrackingOptionChange = e => {
        let newType = {...type, ["tracking_option"]: trackingOptionObjects[e.target.value]}
        setType(newType);
    };
    return (
        <Box>
            <details>
                <summary><Title>Add Movement Type</Title></summary>
            <Columns isMultiline>
                <Column>
                    <Field>
                        <label className="label">Name</label>
                        <Input
                            name={"name"}
                            type={"text"}
                            onChange={onChange}
                            value={type.name}
                        />
                    </Field>
                </Column>
                <Column>
                    <TrackingOptionsPicker
                        name={"tracking_option"}
                        label={"Tracking Option"}
                        onChange={onTrackingOptionChange}
                        inlineEdit={false}
                        editable={true}
                        options={trackingOptions}
                        value={type.tracking_option}
                        blank={true}
                    />
                </Column>
                <Column>
                    <label className="label">Invoice Address</label>
                    <Select
                        name={"invoice_address"}
                        onChange={onChange}
                        value={type.invoice_address}
                    >
                        <option key={0} value={"start"}>START</option>
                        <option key={1} value={"end"}>END</option>
                    </Select>
                </Column>
            </Columns>
            <Columns isMultiline>
                <Column>
                    <Button
                        color={"success"}
                        onClick={() => onSave(type)}
                        isFullWidth
                    >
                        Create
                    </Button>
                </Column>
            </Columns>
            </details>
        </Box>
    );


}